import React, {useEffect, useMemo, useState} from "react";
import rowNextIcon from "../../img/nextRowIcon.svg";
import SendForSignature from "../SendForSignature/SendForSignature";
import imageDoc from "../../img/bolDocumentPage1.jpeg";
import {findStatusDocument} from "../../utils/FindStatusDocument/FindStatusDocument";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import {axiosGetIndossamentByBol} from "../../Api/ApiIndossament/axiosGetIndossamentByBol";
import {axiosGetHistoryStatusBol} from "../../Api/ApiHistoryStatus/axiosGetHistoryStatusBol";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import UploadTemplateDocument from "../UploadTemplateDocument/UploadTemplateDocument";
import useGetListTemplate from "../../utils/CustomHooks/useGetListTemplate/useGetListTemplate";
import useOnSetSelectedTemplate from "../../utils/CustomHooks/useOnSetSelectedTemplate/useOnSetSelectedTemplate";

const SelectedDocSetBol = (props) => {

    const {
        selectedCargoCaseBol,
        onEditHandler,
        cargoCaseDocId
    } = props;

    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const [isTextMessage, setTextMessage] = useState('');
    const [currentStatusBol, setCurrentStatusBol] = useState([]);
    const [currentIndossamentBol, setCurrentIndossamentBol] = useState([]);
    const selectedCargoCaseBolFlag = useMemo(() => selectedCargoCaseBol[0]?.vessel?.country?.name,[selectedCargoCaseBol]);
    const { isLinkTemplate} = useOnSetSelectedTemplate(auth, selectedCargoCaseBol[0]?.id, selectedCargoCaseBol[0]?.template?.id, true, selectedCargoCaseBol, undefined);
    // const {isOptionsTemplate} = useGetListTemplate(auth?.user?.organization, 'BOL');

    useEffect(() => {
        if (selectedCargoCaseBol.length !== 0) {

            let isLoading = true;

            axiosGetIndossamentByBol(axiosPrivate, selectedCargoCaseBol[0]?.id, isLoading, setCurrentIndossamentBol);
            axiosGetHistoryStatusBol(axiosPrivate, selectedCargoCaseBol[0]?.id, isLoading, setCurrentStatusBol);

            return () => {
                isLoading = false;
            }
        }
    }, [selectedCargoCaseBol, axiosPrivate])

    return (
        <div className="selected-doc-set-bol__container">
            <div className="selected-doc-set-bol-row-current-bol">
                <p className="selected-doc-set-bol-row-current-bol__label-bol">BOL</p>
                <img className="selected-doc-set-bol-row-current-bol__icon" src={rowNextIcon} alt={'иконка стрелочка'}/>
                <p className="selected-doc-set-bol-row-current-bol__current-bol">{selectedCargoCaseBol[0]?.bookingRef}</p>
            </div>
            <div className="selected-doc-set-bol-title">
                <div className="selected-doc-set-bol-title__bol-doc-icon">
                    <p className="selected-doc-set-bol-title__bol-doc-name">{selectedCargoCaseBol[0]?.bookingRef}</p>
                    <img className="selected-doc-set-bol-title__icon-status" src={findStatusDocument(selectedCargoCaseBol[0]?.status)} alt={'иконка'}/>
                </div>
                <div className="selected-doc-set-bol-title__select-template">
                    {/*<UploadTemplateDocument*/}
                    {/*    isOptionsTemplate={isOptionsTemplate}*/}
                    {/*    isSelectTemplate={isSelectTemplate}*/}
                    {/*    setSelectTemplate={setSelectTemplate}*/}
                    {/*    isLinkTemplate={isLinkTemplate}*/}
                    {/*/>*/}
                    <SendForSignature
                        selectedCargoCaseBol={selectedCargoCaseBol}
                        onEditHandler={onEditHandler}
                        cargoCaseDocId={cargoCaseDocId}
                        setTextMessage={setTextMessage}
                        isLinkTemplate={isLinkTemplate}
                    />
                </div>
            </div>
            <div className="selected-doc-set-bol-message">
                <p>{isTextMessage}</p>
            </div>
            <div className="selected-doc-set-bol-doc-info">
                <div className="selected-doc-set-bol-doc-info__selected-doc-image-page">
                    <img className="selected-doc-set-bol-doc-info__selected-doc-image" src={imageDoc} alt={'изображение документа'}/>
                </div>
                {selectedCargoCaseBol.map((el, i) => {
                    return (
                        <div key={i} className="selected-doc-set-bol-doc-info__text-fields">
                            <h4 className="selected-doc-set-bol-doc-info__selected-doc-info-title">Doc info</h4>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Bill of lading number</label>
                                    <p>{el?.bookingRef}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Description of Goods</label>
                                    <p>{el?.descriptionOfGoods}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Port of loading</label>
                                    <p>{el?.portOfLoadingName}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Port of discharge</label>
                                    <p>{el?.portOfDischargeName}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Date bill of lading</label>
                                    <p>{el?.dateOfLoading}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Flag</label>
                                    <p>{selectedCargoCaseBolFlag}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Captain</label>
                                    <p>{el?.captain?.firstName ?? 'firstName'} {el?.captain?.lastName ?? 'lastName'}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Vessel</label>
                                    <p>{el?.vesselName}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Consignee</label>
                                    <p>{el?.consignee}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Shipper</label>
                                    <p>{el?.shipperName}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Gross quantity</label>
                                    <p>{el?.grossQuantity}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Net quantity</label>
                                    <p>{el?.netQuantity}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>BBLS gross</label>
                                    <p>{el?.bblsGross}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>BBLS net</label>
                                    <p>{el?.bblsNet}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-bol-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Cargo on board remark</label>
                                    <p>{el?.bolRemarks}</p>
                                </div>
                                <div className="selected-doc-set-bol-doc-info__selected-doc-info-input">
                                    <label>Freigh payment remark</label>
                                    <p>{el?.notify}</p>
                                </div>
                            </div>
                        </div>
                    )})}
            </div>
            <div className={currentIndossamentBol.length !== 0 ? "selected-doc-set-bol__indossamnet" : "selected-doc-set-bol__indossamnet hide"}>
                <div className="selected-doc-set-bol__change-log">
                    <h4 className="selected-doc-set-bol__change-log-title">Indossament</h4>
                </div>
                <div className="selected-doc-set-bol__change-log-table-header">
                    <p>Endosser</p>
                    <p>Endossat</p>
                    <p>Signature</p>
                    <p>Date</p>
                </div>
                {currentIndossamentBol.map((el) => {
                    return (
                        <div key={el?.id} className="selected-doc-set-bol__change-log-table-row">
                            <p>{el?.indossant.name}</p>
                            <p>{el?.indossat.name}</p>
                            <div className="selected-doc-set-bol__change-log-table-row-img-status">
                                <span className="selected-doc-set-bol__indossamne-sign">{el?.sign}</span>
                            </div>
                            <p>{el?.date}</p>
                        </div>
                    )
                    })}
            </div>
            <div className="selected-doc-set-bol__change-log">
                <h4 className="selected-doc-set-bol__change-log-title">Change log</h4>
            </div>
            <div className="selected-doc-set-bol__change-log-table-header">
                <p>Action</p>
                <p>Doer</p>
                <p>Status</p>
                <p>Date</p>
            </div>
            {currentStatusBol.map((el) => {
                return (
                    <div key={el?.id} className="selected-doc-set-bol__change-log-table-row">
                        <p>{el?.description}</p>
                        <p>{el?.user}</p>
                        <div className="selected-doc-set-bol__change-log-table-row-img-status">
                            <img className="selected-doc-set-bol__change-log-img" src={findStatusDocument(el?.status)} alt={'иконка статуса'}/>
                        </div>
                        <p>{el?.date}</p>
                    </div>
                )})}
        </div>
    )
}
export default SelectedDocSetBol;